export const RightIcon = () => {
	return (
		<div style={{ height: 'fit-content', display: 'flex' }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path
					d="M9.18934 8.25L5.21967 12.2197C4.92678 12.5126 4.92678 12.9874 5.21967 13.2803C5.51256 13.5732 5.98744 13.5732 6.28033 13.2803L10.7803 8.78033C11.0732 8.48744 11.0732 8.01256 10.7803 7.71967L6.28033 3.21967C5.98744 2.92678 5.51256 2.92678 5.21967 3.21967C4.92678 3.51256 4.92678 3.98744 5.21967 4.28033L9.18934 8.25Z"
					fill="#C7C9CC"
				/>
			</svg>
		</div>
	)
}
